
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { formatDate } from '../../utils/publish'

@Component({
  name: 'package',
  components: { }
})
export default class AddList extends Vue {
    @Prop() prop_course_id: string
    @Prop() is_show_course_record_info: boolean

    courseRecordList = []
    page = 1
    course_id: string = ''


    mounted() {
        this.course_id = this.prop_course_id
    }
    @Watch('is_show_course_record_info')
    getDetails(oldVal, newVal) {
      if(this.is_show_course_record_info) {
        this.course_id = this.prop_course_id
        this.getSignHistoryList()
      }
    }

    getTime(val, type) {
        return formatDate(val, type)
    }
    handleClose() {
        this.$emit('close-record-list', false)
    }

    // 历史签到记录
    async getSignHistoryList() {
        const res: any = await CourseModule.courseRecordList({ 'course_id': this.course_id })
        if (res.code === 200) {
            this.courseRecordList = res.data.list
        }
    }
}
